import React, { useContext, useState, useEffect, useRef } from "react";
import { Field, useFormikContext, Formik } from "formik";
import { Button } from "react-bootstrap";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  manageMaintenanceStore,
  setManagePageLevelData,
} from "../../../contexts";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import {
  ManageMaintenanceLayout,
  LoaderWrapper,
  CsplTable as Table,
  FieldInput,
  Link,
} from "../../../components";
import {
  manageMaintenanceFormNames,
  managePlanFormNames,
  MANAGE_MAINTENANCE_ROUTES,
  getFlowBasedFormValues,
  FLOW_TYPES,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  getAdvancedPathWithParam,
  formFields,
  getPathWithParam,
  EMPLOYEE_RECORDS_TO_FETCH,
  PLANGROUP_RECORDS_TO_FETCH,
} from "../../../utils";
import { Select, SearchDropdownWithAPI } from "../../../components";
import { Row, Col, Form } from "react-bootstrap";
import {
  getCompanyCount,
  postCompanyGridView,
  getPlanGroups,
} from "../../../services";
import { isEmpty } from "lodash";
import InfiniteScroll from "react-infinite-scroller";

const ManagePlanGroupContainer = (props) => {
  const { history } = props;
  const { flow } = useRouterParams();
  const { state, dispatch } = useContext(manageMaintenanceStore);
  const formName = manageMaintenanceFormNames.MANAGE_PLAN_GROUP;
  const fields1 = formFields[formName];
  const fields = { planTypes: "planTypes" };
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  //const [planGroupInfo, setplanGroupInfo] = useState([]);
  const [selectedPlanTypes, setSelectedPlanTypes] = useState([]);
  const [filteredResponse, setFilteredResponse] = useState([]);
  let searchChangeTimeout = null;
  const [searchValueDisplayed, setSearchValueDisplayed] = useState("");
  const [searchText, setSearchText] = useState("");
  const searchPayloadKey = "searchString";
  const initialValues = {};
  const [apiLoading, setApiLoading] = useState(false);

  const [toggle, setToggle] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [append, setAppend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [request, setRequest] = useState({
    //fileId: fileId,
    from: 0,
    offset: PLANGROUP_RECORDS_TO_FETCH,
    searchInput: "",
  });
  useDeepEffect(() => {
    setIsLoading(true);

    getPlanGroups(request)
      .then((response) => {
        if (response?.length < PLANGROUP_RECORDS_TO_FETCH)
          setStopInfiniteScroll(true);

        if (append && searchTerm == "")
          setFilteredResponse([...filteredResponse, ...response]);
        else {
          setFilteredResponse(response);
          setStopInfiniteScroll(false);
        }
        setIsLoading(false);
      })

      .catch((error) => {
        setIsLoading(false);
      });
  }, [request, toggle]);

  useDeepEffect(() => {
    if (request.searchInput == "")
      setRequest({
        ...request,
        from: 0,
        offset: PLANGROUP_RECORDS_TO_FETCH,
        searchInput: "",
      });
  }, [request.searchInput]);

  const { response, loading } = useRequest({
    method: postCompanyGridView,
    payload: {
      [searchPayloadKey]: searchText.trim(),
      from: 1,
      to: 100,
      showTerminated: true,
    },
    defaultResponse: [],
    triggerOnlyOnUpdate: true,
  });

  const buttons = [
    {
      label: "Create Plan Group",
      variant: "primary",
      type: "button",
      link: getAdvancedPathWithParam({
        path: MANAGE_MAINTENANCE_ROUTES.ADD_PLAN_GROUP,
        pathParam: [FLOW_TYPES.ADD],
      }),
      isAddButton: true,
    },
  ];

  const handleSearchChange = (val) => {
    setSearchText(val);
  };
  const planGroupNames = [];

  const handleTypes = (e) => {
    setSelectedPlanTypes(e.target.value);
  };

  const defaultOption = [{ label: "All", value: null }];

  // useEffect(() => {
  //   setApiLoading(true);
  //   getPlanGroups(request).then((response) => {
  //     setFilteredResponse(response);
  //     setApiLoading(false);
  //   });
  // }, []);
  const onFormSubmit = (values) => {
    if (values[fields1.search]) {
      getPlanGroups(request).then((response) => {
        setFilteredResponse(response);
      });
    } else {
      getPlanGroups(request).then((response) => {
        setFilteredResponse(response);
      });
    }
  };

  return (
    <ManageMaintenanceLayout buttons={buttons}>
      <Formik
        initialValues={{
          ...initialValues,
          [fields1.search]: "",
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
      >
        {(formProps) => {
          const {
            setFieldValue,
            values,
            handleChange,
            handleSubmit,
            setValues,
            setSubmitting,
            ...rest
          } = formProps;

          // const searchByPlanName = () => {
          //   if (values[fields1.search]) {
          //     getPlanGroups(request).then((response) => {
          //       setFilteredResponse(response);
          //     });
          //   } else {
          //     getPlanGroups(request).then((response) => {
          //       setFilteredResponse(response);
          //     });
          //   }
          // };

          const onViewPlanGroupClick = (index) => {
            setSubmitting(true);
            window.setTimeout(() => {
              history.push(
                getPathWithParam({
                  path: MANAGE_MAINTENANCE_ROUTES.ADD_PLAN_GROUP,
                  pathParam: [FLOW_TYPES.EDIT, index],
                })
              );
            }, 10);
          };

          return (
            <LoaderWrapper isLoading={loading || apiLoading || isLoading}>
              <div
                className="w-100 maintenance-container"
                style={{ paddingRight: "10px" }}
              >
                <div className="d-flex">
                  <div style={{ position: "relative", display: "flex" }}>
                    <Form
                      autoComplete="off"
                      className="h-10"
                      onSubmit={handleSubmit}
                      validated={!isEmpty(rest.errors)}
                    >
                      <Field
                        label="Search"
                        name={fields1.search}
                        //   {...rest}
                        type="text"
                        size="md"
                        //isRequired
                        autoComplete="off"
                        placeholder="Search"
                        value={values[fields1.search]}
                        onBlur={handleChange}
                        onChange={(e) => {
                          setFieldValue(fields1.search, e.target.value);
                          setRequest({
                            ...request,
                            from: 0,
                            offset: PLANGROUP_RECORDS_TO_FETCH,
                            searchInput: e.target.value,
                          });
                        }}
                        // disabled={isEdit}
                        component={FieldInput}
                      />
                      {values[fields1.search]?.length != 0 && (
                        <div
                          style={{
                            position: "absolute",
                            right: "5px",
                            top: "5px",
                            height: "100%",
                            marginTop: "30px",
                            marginRight: "5px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faTimes}
                            color="#000"
                            size="sm"
                            onClick={() => {
                              setFieldValue(fields1.search, "");
                            }}
                          />
                        </div>
                      )}
                    </Form>
                  </div>
                  <div
                    style={{
                      marginLeft: "2rem",
                    }}
                  >
                    <Button
                      variant="secondary"
                      className="plan-group-search"
                      type="submit"
                      onClick={() => {
                        setRequest({
                          ...request,
                          from: 0,
                          offset: PLANGROUP_RECORDS_TO_FETCH,
                          searchInput: values[fields1.search],
                        });
                        handleSubmit();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>
                <div
                  style={{
                    height: "60vh",
                    overflowX: "hidden",
                    overflowY: "auto",
                  }}
                >
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={() => {
                      setAppend(true);
                      setRequest({
                        ...request,
                        from: filteredResponse?.length,
                        offset: PLANGROUP_RECORDS_TO_FETCH,
                        searchInput: values[fields1.search],
                      });
                    }}
                    hasMore={!stopInfiniteScroll}
                    initialLoad={false}
                    threshold={100}
                    useWindow={false}
                    loader={
                      isLoading ? (
                        <div className="loader" key={0}>
                          Loading ...
                        </div>
                      ) : filteredResponse?.length < 1 ? (
                        <div className="no-found">No Records Found</div>
                      ) : null
                    }
                  >
                    {filteredResponse?.length > 0 ? (
                      filteredResponse?.map((data, index) => (
                        <div className="plan-group-tile w-100 ">
                          <Row>
                            <Col md="3">
                              <p className="plan-group-tile-header">Name</p>
                              <Link
                                onClick={() => {
                                  onViewPlanGroupClick(data.id);
                                }}
                              >
                                <p className="plan-group-tile-content plan-group-blue">
                                  {data.name}
                                </p>
                              </Link>
                            </Col>
                            <Col>
                              <Row>
                                <Col md="9">
                                  <p className="plan-group-tile-header">
                                    Description
                                  </p>
                                  <p className="plan-group-tile-content">
                                    {data.description}
                                  </p>
                                </Col>

                                {/* <Col md="5">
                              <p className="plan-group-tile-header">Type</p>
                              <p className="plan-group-tile-content">
                                {data.Type}
                              </p>
                            </Col> */}

                                <Col>
                                  <p className="plan-group-added-tile-header">
                                    Plans Added
                                  </p>
                                  <div className="float grey-bg d-flex mar-bot-4">
                                    <p className="plan-group-tile-content pad-right-6 pad-top-6">
                                      {data.count}
                                    </p>
                                  </div>
                                  <div class="clearfix"></div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      ))
                    ) : (
                      <h4> No records available</h4>
                    )}
                  </InfiniteScroll>
                </div>
              </div>
            </LoaderWrapper>
          );
        }}
      </Formik>
    </ManageMaintenanceLayout>
  );
};

export default ManagePlanGroupContainer;
